import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import "./Addload.scss";

const CREATE_BID_MUTATION = gql`
  mutation CreateBidOnLoad($BidDetails: BidDetailsInput, $BidsInput: [TripBookingsInput], $UserId: ID) {
    CreateBidOnLoad(BidDetails: $BidDetails, BidsInput: $BidsInput, UserId: $UserId) {
      _id
    }
  }
`;

const BidResultsPage = ({ show, setShowModal, totalWeight, LoadId, TypeOfPortal, individualBids, vehicleData }) => {
  //  React's `useState` to maintain the component's visibility (`openItems`) based on the `show` prop.
  const [openItems, setOpenItems] = useState(show);
  // - Employs Redux's `useDispatch` and `useSelector` for interacting with the application's global state, particularly for accessing form data (`FormData`) relevant to the bidding process.
  const dispatch = useDispatch();
  const FormData = useSelector((store) => store.FormFieldData);

  // Defines a GraphQL mutation (`CREATE_BID_MUTATION`) for creating bid details and committing vehicles to a load.
  // This mutation is invoked via Apollo Client's `useMutation` hook, which is configured with custom headers and a fetch policy.
  const [createBid, { loading: CreateLoads, error, data }] = useMutation(CREATE_BID_MUTATION, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });

  const Closeformfunction2 = () => {
    setShowModal();
    setOpenItems(false);
  };

  // `submit` function constructs the payload for the GraphQL mutation based on the form data stored in Redux.
  // It includes committed vehicle details and bid specifics, such as the bid note, confirmed quantity, load ID, number of vehicles, and the bid price.
  let submit = async () => {
    let commitedVehicleInput = [];
    let len = FormData?.fielddata?.Bidding_Fields?.No_Of_Vehicles;
    for (let i = 1; i <= len; i++) {
      let val = vehicleData[i];
      commitedVehicleInput.push({
        Vehicle_Category_Type: val?.category?._id,
        Total_Weight: val?.Total_Weight,
      });
    }

    await createBid({
      variables: {
        BidsInput: commitedVehicleInput,
        BidDetails: {
          Bid_Note: FormData?.fielddata?.Note_Data?.Bid_Note,
          Confirm_Qty: totalWeight,
          LoadId: LoadId,
          No_Of_Vehicle: Number(len),
          Price: Number(FormData?.fielddata?.User_Details_For_Bid?.Bid),
        },
        UserId: FormData?.masterData?.UserId?._id,
      },
    })
      .then((res) => {
        // Upon successful submission, a success toast notification is displayed, and the component is closed using `Closeformfunction2`.
        // The application's state is updated to trigger a refetch of relevant data.
        SuccessToast("Bid Placed Successfully");
        Closeformfunction2();
        dispatch({ type: "Refetch", payload: true });
      })
      .catch((err) => {
        // settoggle(toggle);
        // Handles errors during the bid submission process by displaying an error toast notification.
        ErrorToast(err.message);
      });
  };
  // component is wrapped in a `Reactportal`, providing a modal-like interface for displaying bid results and submission feedback. This portal is configured with props to manage its visibility and behavior.
  return (
    <Reactportal open={openItems} onClose={Closeformfunction2} TypeOfPortal={"Bid Details"}>
      <div className="Bid Results">
        <div>
          {/*Dynamically displays individual bids for each committed vehicle, outlining the bid amount for transparency and user understanding. */}
          {individualBids.map((bid, index) => (
            <div key={index}>
              <p>
                Vehicle {index + 1} Bid: {bid}
              </p>
            </div>
          ))}
        </div>
        {/* Includes informational points (`<div className="Bidpoints">`) to communicate important bid conditions and penalties to the user, ensuring they understand the implications of their bid. */}
        <div className="Bidpoints">
          <ul type="desc">
            <li>Bid Once Placed can't be withdrawn.</li>
            <li>Vehicle commited can be changed in the later stage.</li>
            <li>
              If the load is awarded then you have to place the vehicle, <br />
              If vehicle not placed then a penality of Rs: 500/- will be
              <br /> deducted from your account and your rating will also be <br /> downgraded
            </li>
          </ul>
        </div>
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitform={submit}
        SaveAndClose={() => {
          submit();
        }}
        handleformclose={() => {
          Closeformfunction2();
          setOpenItems(false);
        }}
        loadingState={CreateLoads}
      />
    </Reactportal>
  );
};

export default BidResultsPage;
